import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
    apiVersion: "2014-06-30",
    disableHostPrefix: false,
    regionInfoProvider: defaultRegionInfoProvider,
    signingName: "cognito-identity"
};
//# sourceMappingURL=runtimeConfig.shared.js.map